import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RedirectManagerService {
  private scrollPositions: Map<string, number> = new Map();
  router = inject(Router);

  /** Contains the key value pair of type and a redirect url */
  redirectionMap = new Map<string, string>()

  saveRoute(type:string, url:string) {
    localStorage.setItem(type, url);
  }

  deleteRoute(route:string):void {
    localStorage.removeItem(route);
  }

  getRoute(type:string): string | null {
    const url = localStorage.getItem(type)
    if(url && typeof url === 'string') {
      return url as string;
    }
    return null;
  }

  // Save the scroll position for a given page or element
  saveScrollPosition(key: string, position: number): void {
    this.scrollPositions.set(key, position);
  }

  // Get the saved scroll position for a given page or element
  getScrollPosition(key: string): number | undefined {
    return this.scrollPositions.get(key);
  }
}
